import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "framer-motion";
import { ButtonHTMLAttributes } from "react";
import { Button } from "../Button";
export const ModalHeader = t0 => {
  const $ = _c(3);
  const {
    children,
    className
  } = t0;
  const t1 = `bg-white px-4 pb-3 pt-4 sm:px-6 ${className}`;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const ModalBody = t0 => {
  const $ = _c(3);
  const {
    children,
    className
  } = t0;
  const t1 = `mb-2 bg-white px-4 py-3 sm:px-6 ${className}`;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const ModalFooter = t0 => {
  const $ = _c(3);
  const {
    children,
    className
  } = t0;
  const t1 = `bg-gray-50 px-4 py-3 sm:px-6 ${className}`;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const modalOverlayVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1
  }
};
const modalVariants = {
  hidden: {
    opacity: 0,
    scale: 0.99
  },
  visible: {
    opacity: 1,
    scale: 1
  }
};
export const Modal = t0 => {
  const $ = _c(7);
  const {
    children,
    className,
    isOpen
  } = t0;
  const wrapperClassname = isOpen ? "fixed z-50 inset-0 overflow-y-auto " : "fixed z-50 inset-0 overflow-y-auto hidden";
  let t1;
  if ($[0] !== children || $[1] !== className || $[2] !== isOpen || $[3] !== wrapperClassname) {
    t1 = isOpen ? <motion.div transition={{
      duration: 0.15
    }} variants={modalOverlayVariants} initial="hidden" animate="visible" exit="hidden" className={wrapperClassname}><div className="flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0"><div className="fixed inset-0 z-0 transition-opacity" aria-hidden="true"><div className="absolute inset-0 bg-gray-500 opacity-75" /></div><span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">​</span><motion.div variants={modalVariants} className={`relative z-10 inline-block transform overflow-hidden rounded-2xl bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle ${className}`}>{children}</motion.div></div></motion.div> : null;
    $[0] = children;
    $[1] = className;
    $[2] = isOpen;
    $[3] = wrapperClassname;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
};
export const ModalSuccessButton = t0 => {
  const $ = _c(5);
  const {
    children,
    className,
    onClick,
    type
  } = t0;
  const t1 = type ?? "button";
  const t2 = `focus:outline-hidden inline-flex justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2 ${className}`;
  let t3;
  if ($[0] !== children || $[1] !== onClick || $[2] !== t1 || $[3] !== t2) {
    t3 = <Button type={t1} className={t2} onClick={onClick}>{children}</Button>;
    $[0] = children;
    $[1] = onClick;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export const ModalCancelButton = t0 => {
  const $ = _c(4);
  const {
    children,
    className,
    onClick
  } = t0;
  const t1 = `focus:outline-hidden inline-flex justify-center rounded-md border border-gray-300 bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2 ${className}`;
  let t2;
  if ($[0] !== children || $[1] !== onClick || $[2] !== t1) {
    t2 = <button type="button" className={t1} onClick={onClick}>{children}</button>;
    $[0] = children;
    $[1] = onClick;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};